export enum AssignmentReportTypeEnum {
  AreaReport = "areaReport",
  PassengerReport = "passengerReport",
  AmBusArrivalReport = "amBusArrivalReport",
  AssignmentSummaryReport = "assignmentSummaryReport",
}

export const assignmentReportTypeList = [
  {
    id: AssignmentReportTypeEnum.AreaReport,
    name: "Area Report",
  },
  {
    id: AssignmentReportTypeEnum.PassengerReport,
    name: "Passenger Report",
  },
  {
    id: AssignmentReportTypeEnum.AmBusArrivalReport,
    name: "AM Bus Arrival Report",
  },
];

export const assignmentArrivalStatusType = [
  { id: "bus_on_time", name: "Bus on Time" },
  { id: "bus_late", name: "Bus Late" },
];